import {
  EMAIL_LOGS_SETTINGS_LABEL,
  EMAIL_LOGS_SETTINGS_PATH,
  MESSAGES_LABEL,
  MESSAGES_PATH,
  NEURAL_NETWORK_LOGS_SETTINGS_LABEL,
  NEURAL_NETWORK_LOGS_SETTINGS_PATH,
  PAYMENT_DOCUMENTS_LABEL,
  PAYMENT_DOCUMENTS_PATH,
  SYSTEM_SETTINGS_LABEL,
} from '@app/constants';

export const menu = [
  {
    groupName: SYSTEM_SETTINGS_LABEL,
    groupTestId: 'system-settings-title',
    items: [
      {
        name: MESSAGES_LABEL,
        path: MESSAGES_PATH,
        itemDataTestId: 'message-log',
      },
    ],
  },
  {
    groupName: 'Логи запросов',
    groupTestId: '',
    items: [
      {
        name: NEURAL_NETWORK_LOGS_SETTINGS_LABEL,
        path: NEURAL_NETWORK_LOGS_SETTINGS_PATH,
        itemDataTestId: '',
      },
      {
        name: EMAIL_LOGS_SETTINGS_LABEL,
        path: EMAIL_LOGS_SETTINGS_PATH,
        itemDataTestId: '',
      },
    ],
  },
  {
    groupName: 'Документооборот',
    groupTestId: '',
    items: [
      {
        name: PAYMENT_DOCUMENTS_LABEL,
        path: PAYMENT_DOCUMENTS_PATH,
        itemDataTestId: '',
      },
    ],
  },
];
